/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventIndex: NonNullable<unknown> }} Event_Subtitle_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Subtitle Event {eventIndex}" |
*
* @param {Event_Subtitle_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_subtitle_aria_label = /** @type {((inputs: Event_Subtitle_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Subtitle_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Evenement de sous-titre ${i?.eventIndex}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Untertitel-Ereignis ${i?.eventIndex}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sottotitolo Evento ${i?.eventIndex}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Событие субтитров ${i?.eventIndex}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Evento de subtítulos ${i?.eventIndex}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`字幕事件${i?.eventIndex}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`字幕イベント ${i?.eventIndex}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`उपशीर्षक घटना ${i?.eventIndex}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Evento de legenda ${i?.eventIndex}`)
	return /** @type {LocalizedString} */ (`Subtitle Event ${i?.eventIndex}`)
});